import React from 'react'
import LegalPageLayout from './LegalPageLayout'

/*
 * MENTIONS LÉGALES — Clinique du Grand Paris
 *
 * KBIS info + hébergeur (OVH) confirmed by David's office 2026-05-13.
 */

const MentionsLegalesPage = () => {
  return (
    <LegalPageLayout
      title="Mentions Légales"
      subtitle="Informations légales relatives au site cliniquedugrandparis.com"
      lastUpdated="14 mai 2026"
    >
      <h2>1. Éditeur du site</h2>
      <div className="legal-card">
        <p><strong>Clinique du Grand Paris</strong></p>
        <p>
          <strong>Forme juridique :</strong> SAS au capital de 1&nbsp;200&nbsp;€<br />
          <strong>Siège social :</strong> 37A Avenue d'Iéna, 75116 Paris, France<br />
          <strong>SIRET :</strong> 840 762 967 00023<br />
          <strong>RCS :</strong> RCS Paris 840 762 967<br />
          <strong>TVA intracommunautaire :</strong> FR47840762967
        </p>
        <p>
          <strong>Téléphone :</strong> 01 48 66 20 35<br />
          <strong>Email :</strong> contact@cliniquedugrandparis.com
        </p>
      </div>

      <h2>2. Directeur de la publication</h2>
      <p>
        <strong>Dr Lionel Choukroun</strong>, chirurgien esthétique, médecin responsable de la Clinique du Grand Paris.<br />
        Inscrit à l'Ordre des Médecins — numéro RPPS : 10000580810.
      </p>

      <h2>3. Hébergement</h2>
      <div className="legal-card">
        <p>
          <strong>OVH SAS</strong><br />
          2 rue Kellermann, 59100 Roubaix, France<br />
          Téléphone : 1007<br />
          Site : <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer">www.ovhcloud.com</a>
        </p>
      </div>

      <h2>4. Conception et développement</h2>
      <p>
        Site conçu et développé par <strong>Ricopoulos</strong> — services d'intelligence artificielle pour les
        cabinets médicaux et établissements de soins.<br />
        Contact : <a href="https://ricopoulos.com" target="_blank" rel="noopener noreferrer">ricopoulos.com</a>
      </p>

      <h2>5. Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu du site (textes, images, vidéos, logos, photographies, illustrations,
        éléments graphiques, sons, animations, code source) est protégé par le droit d'auteur, le
        droit des marques et plus généralement par la propriété intellectuelle.
      </p>
      <p>
        Toute reproduction, représentation, modification, publication, transmission, dénaturation,
        totale ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur quelque
        support que ce soit est interdite sans l'autorisation écrite préalable de la Clinique du Grand Paris.
      </p>
      <p>
        Les photographies de patients publiées sur le site le sont avec leur consentement écrit et
        explicite. Les visages sont systématiquement anonymisés conformément aux règles applicables
        à la publicité médicale en France.
      </p>

      <h2>6. Marques</h2>
      <p>
        Les marques « <strong>SAPHORÏ®</strong> », « <strong>CHOÏ</strong> » et « <strong>SAPHIR</strong> »
        ainsi que les autres dénominations citées sur le site sont la propriété de leurs détenteurs
        respectifs. La Clinique du Grand Paris utilise certaines de ces techniques sous accord ou licence.
      </p>

      <h2>7. Limitation de responsabilité</h2>
      <p>
        Les informations diffusées sur le site cliniquedugrandparis.com sont présentées à titre informatif
        et général. <strong>Elles ne sauraient en aucun cas constituer un avis médical, un diagnostic ou
        une prescription de traitement.</strong>
      </p>
      <p>
        Toute décision relative à un acte médical ou chirurgical doit faire l'objet d'une consultation
        préalable avec un professionnel de santé qualifié. La Clinique du Grand Paris recommande à toute
        personne intéressée par une intervention de prendre rendez-vous pour un bilan personnalisé.
      </p>
      <p>
        La Clinique du Grand Paris ne saurait être tenue responsable des dommages directs ou indirects
        résultant de l'accès au site, de son utilisation, ou de l'impossibilité d'y accéder.
      </p>

      <h2>8. Assistant conversationnel Ben</h2>
      <p>
        Le site intègre un assistant conversationnel appelé <strong>Ben</strong>, propulsé par une intelligence
        artificielle (technologie ElevenLabs Conversational AI). Ben fournit des informations générales
        et oriente les utilisateurs vers une consultation. <strong>Ben ne pose pas de diagnostic et ne
        prescrit aucun traitement.</strong> Toute information échangée avec Ben est confidentielle et traitée
        conformément à la <a href="/politique-confidentialite">Politique de Confidentialité</a> du site.
      </p>

      <h2>9. Publicité médicale</h2>
      <p>
        Conformément au Code de la santé publique et aux recommandations du Conseil National de l'Ordre
        des Médecins, les contenus de communication publiés par la Clinique du Grand Paris (site web,
        réseaux sociaux, campagnes publicitaires) :
      </p>
      <ul>
        <li>Sont à finalité informative et non comparative dévalorisante</li>
        <li>Ne comportent aucune mention pouvant induire en erreur sur les résultats attendus</li>
        <li>Identifient clairement le Dr Lionel Choukroun comme praticien responsable</li>
        <li>Respectent l'anonymat des patients dont les images sont éventuellement diffusées</li>
      </ul>

      <h2>10. Droit applicable</h2>
      <p>
        Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux
        français seront seuls compétents.
      </p>

      <h2>11. Contact</h2>
      <div className="legal-card">
        <p>
          Pour toute question relative aux présentes mentions légales :<br />
          <strong>Email :</strong> contact@cliniquedugrandparis.com<br />
          <strong>Adresse postale :</strong> Clinique du Grand Paris, 37A Avenue d'Iéna, 75116 Paris
        </p>
      </div>
    </LegalPageLayout>
  )
}

export default MentionsLegalesPage
